<div class="left-container-toolbar">
  @if (isStandardView) {
    <button (click)="createHyperlink()" class="primary" type="button">
      {{ "generic.toolbar.addNew" | translate }}
    </button>
  }

  @if (isCreateView || isEditView) {
    <button class="primary" type="submit" form="register-form">
      {{ "generic.buttons.save" | translate }}
    </button>
  }

  @if (isInfoView) {
    <button (click)="editHyperlink(selectedItem)" class="primary">
      {{ "generic.buttons.edit" | translate }}
    </button>
    <button (click)="deleteHyperlink()" class="danger">
      {{ "generic.buttons.delete" | translate }}
    </button>
  }
</div>
<div class="right-container-toolbar">
  @if (isStandardView) {
    <app-search-bar [(value)]="searchValue" [data]="data" />
  }
</div>
